import * as R from 'ramda';
import React from 'react';
import { stringHelper } from 'utils/stringHelper';

import { FieldSelect } from 'reactComponents/Forms/FieldSelect';

import styles from './FlavorSelect.css';

export const FlavorSelect = ({
    flavors,
    minFlavor = undefined,
    additionalOptions = [],
    dataTest = 'flavor-select',
    ...otherSelectProps
}) => {
    const options = FlavorSelect.getFlavorsOptions({
        flavors,
        minFlavor,
        additionalOptions,
    });

    const selectedFlavorRenderer = (flavorId) => {
        const selectedOption = options.find(
            (option) => option.value === flavorId,
        );

        if (!selectedOption) {
            return '';
        }

        return (
            <div
                data-test={dataTest}
                className={styles.selectedFlavorContainer}
            >
                <span>{selectedOption.text}</span>
                <span className={styles.selectedFlavorDescription}>
                    {selectedOption.description}
                </span>
            </div>
        );
    };

    return (
        <FieldSelect
            {...{
                dataTest,
                options,
                ...otherSelectProps,
                className: styles.root,
                selectedValueCustomRender: selectedFlavorRenderer,
            }}
        />
    );
};

FlavorSelect.getFlavorsOptions = ({
    flavors,
    minFlavor,
    additionalOptions = [],
}) => {
    if (minFlavor) {
        const isValueSatisfies = (key, flavor) => {
            return R.gte(flavor[key] || 0, minFlavor[key] || 0);
        };

        flavors = flavors.filter((flavor) => {
            return ['vcpus', 'ram', 'disk'].every((key) =>
                isValueSatisfies(key, flavor),
            );
        });
    }

    const options = flavors.map(({ id, vcpus, ram, customFields }) => {
        const ramInGb = Math.round(ram / 1024);
        const ramFormatted = stringHelper.padStartWithStrAsChar(ramInGb, 3);
        const vcpusFormatted = stringHelper.padStartWithStrAsChar(vcpus, 3);
        return {
            value: id,
            text: customFields.shortName,
            key: id,
            description: `${vcpusFormatted} CPU ${ramFormatted} ГБ RAM`,
        };
    });

    if (additionalOptions.length) {
        return [...options, ...additionalOptions];
    }

    return options;
};
